import { autoinject, newInstance } from 'aurelia-framework';
import { observable } from "aurelia-binding";
import { ILookupOptionsFunctionParameter } from "aurelia-materialize-bridge";
import { applicationLogger } from "../../../logging/logger";
import { AdminApi } from "../../../services/admin-api";
import { Kiosk } from "../../../models/kiosk";
import { MaterializeFormValidationRenderer, MdToastService, MdModal } from "aurelia-materialize-bridge";
import { User, TenantUser } from "../../../models/user";
import { ValidationController, ValidationRules } from "aurelia-validation";
import { PasswordGenerator } from "../../../utility/password-generator";
import { OpenIdConnect } from "aurelia-open-id-connect";
import { Tenant } from '../../../models/tenant';
@autoinject
export class Users {
    applicationUserIsGlobalAdministrator: boolean;
    tenantId: string;
    addUserValidationRules: ValidationRules;
    manageUserValidationRules: ValidationRules;
    users: Array<TenantUser>;
    foundUsers: Array<TenantUser>;
    kiosks: Array<Kiosk>;
    addUserModal: MdModal;
    manageUserModal: MdModal;
    newUser: TenantUser;
    selectedUser: TenantUser;
    deleteUserModal: MdModal;
    user: User;
    userQuery: string;
    applicationUserId: string;
    isBatchTransProcessEmailRecipient: boolean;

    selectedKiosks: Array<Kiosk> = new Array<Kiosk>();

    //private _selectedExistingUser: TenantUser;

    //getSelectedExistingUser() {
    //    return this._selectedExistingUser;
    //}

    //setSelectedExistingUser(user: TenantUser) {
    //    this._selectedExistingUser = user;

    //    this.users.push(user);
    //}

    userFilters = [
        { value: '', keys: ['firstName', 'lastName', 'email'] }
    ];

    constructor(private adminApi: AdminApi,
        private toast: MdToastService,
        private openIdConnect: OpenIdConnect,
        @newInstance(ValidationController) private userValidationController: ValidationController) {

        this.openIdConnect.getUser().then(user => {
            this.applicationUserIsGlobalAdministrator = user.profile.role.includes("GlobalAdministrator");
            this.applicationUserId = user.profile.sub;
        });

        this.userValidationController.addRenderer(new MaterializeFormValidationRenderer());

        this.addUserValidationRules = ValidationRules
            .ensure("firstName")
            .required()
            .ensure("lastName")
            .required()
            .ensure("password")
            .required()
            .ensure("email")
            .required()
            .on(TenantUser)
            .rules;

        this.manageUserValidationRules = ValidationRules
            .ensure("firstName")
            .required()
            .ensure("lastName")
            .required()
            .ensure("email")
            .required()
            .on(TenantUser)
            .rules;
    }

    async activate(params: any) {
        this.tenantId = params.tenantId;

        const response = await this.adminApi.getTenantManagementData(this.tenantId);
        if (response.success && response.data) {
           
            this.users = response.data.users;
            this.kiosks = response.data.kiosks;

            this.kiosks.sort((a, b) => a.name.localeCompare(b.name));
        } else {
            applicationLogger.error(response.message);
        }
    }

    async addUser() {
        this.userValidationController.validate().then(async v => {
            if (v.valid) {
                this.newUser.associatedKioskIds = this.selectedKiosks.map(kiosk => { return kiosk.id });
                const response = await this.adminApi.addOrUpdateUser(this.newUser);
                if (response.success) {
                    this.toast.show(response.message);
                    this.users.push(response.data);
                    this.addUserModal.close();
                } else {
                    this.toast.show(response.message, 5000, "red");
                }
            }
        });
    }

    rowSelected($event) {
        console.log($event.detail.row);
    }

    async cancelAddUser() {
        this.addUserModal.close();
    }

    async openAddUserModal() {
        this.newUser = new TenantUser(new User());
        this.newUser.tenantId = this.tenantId;
        this.selectedKiosks = new Array<Kiosk>();
        this.addUserModal.open();
    }

  
    async searchForUser(query: string): Promise<any[]> {
        var result = await this.adminApi.searchForUsers(query);
        if (result.success) {
            //  this.foundUsers = result.data;
            return result.data;
        };
    }

   async optionsFunction(p: ILookupOptionsFunctionParameter<TenantUser>): Promise<TenantUser[]> {
        if (p.value) {

            if (this.users.filter(user => user.id === p.value.id).length > 0) {
                this.toast.show(`'${p.value.firstName} ${p.value.lastName}' is already associated to this tenant.`)
                return Promise.resolve(null);
            }
            else {
                

                // add the user to the list of users - this will update the table
                this.users.push(p.value);
                //  show the manage user modal dialog.  Clicking OK will save the newly associated user.
                await this.manageUser(p.value.id);

                return Promise.resolve([p.value]);
            }
         
            //return Promise.resolve([p.value]);
        }
        else {
            return this.searchForUser(p.filter);
        }
    }

    getDisplayName(x: TenantUser) {
        return `${x.firstName} ${x.lastName} (${x.email})`;
    }


    async manageUser(id: string) {
        const user = this.users.filter(user => user.id === id)[0];
        if (user) {
            this.selectedUser = user;
            this.selectedUser.tenantId = this.tenantId;
            this.selectedKiosks = this.kiosks.filter(kiosk => ((this.selectedUser.associatedKioskIds) as any).includes(kiosk.id));
            this.manageUserModal.open();
        }
    }

    async updateUser(e) {

        this.userValidationController.validate().then(async v => {
            if (v.valid) {
                this.selectedUser.associatedKioskIds = this.selectedKiosks.map(kiosk => { return kiosk.id });
                const response = await this.adminApi.addOrUpdateUser(this.selectedUser);
                if (response.success) {
                    this.toast.show(response.message);
                    const index = this.users.indexOf(this.selectedUser);
                    this.users[index] = response.data;
                    this.manageUserModal.close();
                } else {
                    this.toast.show(response.message, 5000, "red");
                }
            }
        });
    }

    async cancelManageUser() {
        this.manageUserModal.close();
    }

    autoGeneratePassword() {
        this.newUser.password = PasswordGenerator.generatePassword(8);
        this.toast.show(`Password copied to clipboard`);
    }

    disableDeleteUser(id: string): boolean
    {
        return (this.applicationUserId === id);
    }

    async confirmDeleteUser(id: string)
    {
        if (!this.disableDeleteUser(id))
        {
            const user = this.users.filter(user => user.id === id)[0];
            if (user)
            {
                this.selectedUser = user;
                this.deleteUserModal.open();
            }
        }
    }

    async cancelDeleteUser()
    {
        this.deleteUserModal.close();
    }

    async deleteUser(e)
    {
        this.userValidationController.validate().then(async v =>
        {
            if (v.valid)
            {
                const response = await this.adminApi.deleteUser(this.selectedUser);
                if (response.success)
                {
                    this.toast.show(response.message);
                    const index = this.users.indexOf(this.selectedUser);
                    this.users.splice(index, 1);
                    this.deleteUserModal.close();
                } else
                {
                    this.toast.show(response.message, 5000, "red");
                }
            }
        });
    }
}